import * as React from "react"

/**
 * Detecta se o app está rodando como PWA instalado (standalone).
 * Em modo standalone, links com target="_blank" abrem no browser do sistema.
 * Usar target="_self" mantém a navegação dentro do PWA.
 */
export function useIsPWAStandalone() {
  const [isStandalone, setIsStandalone] = React.useState(false)
  React.useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (navigator as { standalone?: boolean }).standalone === true
    setIsStandalone(standalone)
  }, [])
  return isStandalone
}

interface ExternalLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  children: React.ReactNode
}

/**
 * Link para URLs externas. Em PWA standalone, abre no próprio app em vez do browser.
 */
export function ExternalLink({ href, children, target, rel, ...props }: ExternalLinkProps) {
  const isPWA = useIsPWAStandalone()
  const effectiveTarget = isPWA ? "_self" : (target ?? "_blank")
  const effectiveRel = rel ?? "noopener noreferrer"
  return (
    <a href={href} target={effectiveTarget} rel={effectiveRel} {...props}>
      {children}
    </a>
  )
}
